import { API_PATH } from '../../routes/generalPath';

export const ENQUETE_ANSWER_PATH = {
  INDEX: API_PATH.ENQUETE_ANSWER,
  DETAIL: API_PATH.ENQUETE_ANSWER + '/:id',
  INPUT: API_PATH.ENQUETE_ANSWER + '/input/',
};
